import { CheckboxField, useControlledField } from '@frontend/design-system';

export const RowCheckbox = ({
  isSelected,
  onChange,
  isDisabled,
}: {
  isSelected: boolean;
  onChange: () => void;
  isDisabled: boolean;
}) => {
  const selectProps = useControlledField({
    onChange,
    type: 'checkbox',
    value: isSelected,
  });

  return <CheckboxField {...selectProps} name='select-bal' label='' indeterminate={false} disabled={isDisabled} />;
};
